import React from "react";
import TransactionRequestList from "../components/TransactionRequestList";
import PanelLayout from "../components/PanelLayout";
import { ListSkeleton } from "../components/Skeleton";
import Tabs from "../components/Tabs";
import { renderPanelTabLabel } from "../components/PanelAdsHeader";
import { connect } from "react-redux";
import * as actions_pending from "../redux/actions/transactionRequestPendingActions";
import * as actions_finish from "../redux/actions/transactionRequestFinishActions";
import { Translate, I18n } from "react-redux-i18n";

import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import "./styles/Transaction.css";
import "./styles/PanelAds.css";

class TransactionRequest extends React.Component {
  componentDidMount() {
    this.fetchTransactionRequestList();
  }

  fetchTransactionRequestList = async () => {
    try {
      this.props
        .LoadTransactionRequest(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alert(this.props.error);
          }
        });
      this.props
        .LoadTransactionFRequest(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.errorf) {
            alert(this.props.errorf);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadTransactionRequestMore(
          this.props.pageCount,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickLoadMoref = async () => {
    try {
      await this.props
        .LoadTransactionFRequestMore(
          this.props.pageCountf,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { pendingCount, finishedCount } = this.props;

    return (
      <PanelLayout>
        <div className="transaction-page">
          <header className="transaction-page__header">
            <h1 className="transaction-page__title">
              <Translate value="transaction_request" />
            </h1>
          </header>

          <div className="transaction-page__tabs panel-ads-page__tabs">
            <Tabs>
              <div
                tabKey="pending"
                label={renderPanelTabLabel(
                  I18n.t("transaction_tab_pending"),
                  pendingCount
                )}
                className="col-12"
              >
                {this.props.loading ? (
                  <ListSkeleton />
                ) : (
                  <TransactionRequestList
                    transactionList={this.props.transactionList}
                    pageCount={this.props.pageCount}
                    pageSize={this.props.pageSize}
                    loadingMore={this.props.loadingMore}
                    onClickLoadMore={this.onClickLoadMore}
                  />
                )}
              </div>
              <div
                tabKey="finished"
                label={renderPanelTabLabel(
                  I18n.t("transaction_tab_finished"),
                  finishedCount
                )}
                className="col-12"
              >
                {this.props.loadingf ? (
                  <ListSkeleton />
                ) : (
                  <TransactionRequestList
                    transactionList={this.props.transactionfList}
                    pageCount={this.props.pageCountf}
                    pageSize={this.props.pageSizef}
                    loadingMore={this.props.loadingMoref}
                    onClickLoadMore={this.onClickLoadMoref}
                  />
                )}
              </div>
            </Tabs>
          </div>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  const transactionList = reducer.transactionRequestPending.list || [];
  const transactionfList = reducer.transactionRequestFinish.list || [];

  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    transactionList,
    error: reducer.transactionRequestPending.error,
    loading: reducer.transactionRequestPending.loading,

    pageCount: reducer.transactionRequestPending.page_count,
    pageSize: reducer.transactionRequestPending.page_size,
    loadingMore: reducer.transactionRequestPending.loadingMore,

    transactionfList,
    errorf: reducer.transactionRequestFinish.error,
    loadingf: reducer.transactionRequestFinish.loading,

    pageCountf: reducer.transactionRequestFinish.page_count,
    pageSizef: reducer.transactionRequestFinish.page_size,
    loadingMoref: reducer.transactionRequestFinish.loadingMore,

    pendingCount: transactionList.length,
    finishedCount: transactionfList.length,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadTransactionRequest: (user_id, token) =>
    dispatch(actions_pending.loadList({ user_id, token })),
  LoadTransactionFRequest: (user_id, token) =>
    dispatch(actions_finish.loadList({ user_id, token })),
  LoadTransactionRequestMore: (page_count, user_id, token) =>
    dispatch(actions_pending.loadListScroll({ page_count, user_id, token })),
  LoadTransactionFRequestMore: (page_count, user_id, token) =>
    dispatch(actions_finish.loadListScroll({ page_count, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionRequest);
